export const ConfigurationsIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.57525 11.6504H3.97491C3.06839 11.6504 2.5 12.2926 2.5 13.1999V15.6502C2.5 16.5584 3.06596 17.2006 3.97491 17.2006H6.57525C7.4842 17.2006 8.05016 16.5584 8.05016 15.6502V13.1999C8.05016 12.2926 7.4842 11.6504 6.57525 11.6504Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.5119 11.4419C16.1578 11.4419 17.4925 12.7766 17.4925 14.4233C17.4925 16.0693 16.1578 17.404 14.5119 17.404C12.8659 17.404 11.5312 16.0693 11.5312 14.4233C11.5312 12.7766 12.8659 11.4419 14.5119 11.4419Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.19868 8.20319H12.0482C12.5777 8.20319 12.9094 7.63155 12.6475 7.1718L10.2385 2.9425C9.97415 2.4795 9.30765 2.47789 9.0409 2.93925L6.60109 7.16856C6.33594 7.6283 6.66758 8.20319 7.19868 8.20319Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
